(() => {
  angular
    .module('app')
    .controller('clinic.view.hospital.guaranteeLetters', HospitalGuaranteeLettersPageController);

  HospitalGuaranteeLettersPageController.$inject = [
    '$scope',
    '$stateParams',
    '$state',
    '$uibModal',
    '$timeout',
    'abp.services.app.inpatientGuaranteeLetter',
    'abp.services.app.hospitalPanelServiceRequest',
    'Hms.GuaranteeLetters.GuaranteeLetterStatus',
    'Hms.GuaranteeLetters.CaseOrigin',
    'Hms.ServiceRequests.ServiceRequestStatus',
    'moment',
    'appConstants',
    'expiredGuaranteeLetterFlow',
  ];

  function HospitalGuaranteeLettersPageController(
    $scope,
    $stateParams,
    $state,
    $uibModal,
    $timeout,
    inpatientGuaranteeLetterSvc,
    hospitalPanelServiceRequestSvc,
    enumGuaranteeLetterStatus,
    enumCaseOrigin,
    enumServiceRequestStatus,
    moment,
    appConstants,
    expiredGuaranteeLetterFlow
  ) {
    var vm = this;
    vm.loading = 0;
    vm.exporting = 0;
    vm.panelDoctors = [];
    var tenantId = abp.session.tenantId;

    vm.enums = {
      guaranteeLetterStatus: enumGuaranteeLetterStatus,
      caseOrigin: enumCaseOrigin,
      serviceRequestStatus: enumServiceRequestStatus,
    };

    vm.caseOrigins = enumCaseOrigin.values.map((caseOrigin) => ({
      value: caseOrigin.id,
      name: App.localize(caseOrigin.name),
    }));

    $scope.$on('$viewContentLoaded', () => {
      App.initAjax();
    });

    vm.requestParams = {
      filter: $stateParams.letterNumber,
      latestRequestType: $stateParams.latestRequestType,
      status: $stateParams.status,
      letterNumber: $stateParams.letterNumber,
      patient: $stateParams.patient,
      admissionType: $stateParams.admissionType,
      attendingDoctorId: $stateParams.attendingDoctorId,
      caseOrigin: $stateParams.caseOrigin,
      skipCount: $stateParams.skipCount || 0,
      maxResultCount: $stateParams.maxResultCount || appConstants.grid.defaultPageSize,
      sorting: $stateParams.sorting,
    };

    vm.scheduledDateRangeOptions = App.createDateRangePickerOptions();
    vm.scheduledDateRangeModel = {
      startDate: $stateParams.scheduledAdmissionEndDate
        ? moment($stateParams.scheduledAdmissionEndDate)
        : null,
      endDate: $stateParams.scheduledAdmissionEndDate
        ? moment($stateParams.scheduledAdmissionEndDate)
        : null,
    };

    vm.onHoldText = App.localize('GLOnHoldDescription');

    vm.gridOptions = {
      appScopeProvider: vm,
      paginationPageSizes: appConstants.grid.defaultPageSizes,
      paginationPageSize: appConstants.grid.defaultPageSize,
      paginationCurrentPage: 0,
      useExternalPagination: true,
      useExternalSorting: true,
      resizable: true,
      columnDefs: [
        {
          name: 'Actions',
          displayName: 'Actions',
          enableSorting: false,
          width: 100,
          headerCellTemplate: '<span></span>',
          cellTemplate: 'actionTemplate',
        },
        {
          displayName: App.localize('Patient'),
          enableSorting: false,
          field: 'patientName',
          minWidth: 120,
          cellTemplate: 'patientTemplate',
        },
        {
          displayName: App.localize('AdmissionNumber'),
          enableSorting: false,
          field: 'admissionNumber',
          minWidth: 120,
        },
        {
          displayName: App.localize('GuaranteeLetterNumber'),
          enableSorting: false,
          field: 'letterNumber',
          minWidth: 150,
        },
        {
          displayName: App.localize('GlStatus'),
          enableSorting: false,
          field: 'status',
          cellTemplate: 'statusTemplate',
          minWidth: 120,
        },
        {
          displayName: App.localize('LatestRequestType'),
          enableSorting: false,
          field: 'latestRequestDescription',
          cellTemplate: 'latestRequestTemplate',
          minWidth: 100,
        },
        {
          displayName: App.localize('AdmissionType'),
          enableSorting: false,
          field: 'admissionType',
          minWidth: 100,
          cellTemplate: 'admissionTypeTemplate',
        },
        {
          displayName: App.localize('ScheduledAdmissionTime'),
          field: 'scheduledAdmissionTime',
          minWidth: 150,
          cellTemplate: 'scheduledAdmissionTimeTemplate',
        },
        {
          displayName: App.localize('PanelLocation'),
          enableSorting: false,
          field: 'panelLocationName',
          minWidth: 100,
        },
        {
          displayName: App.localize('AttendingDoctor'),
          enableSorting: false,
          field: 'attendingDoctorNames',
          minWidth: 120,
        },
        {
          displayName: App.localize('ClaimNumber'),
          enableSorting: false,
          field: 'claimNumber',
          minWidth: 120,
        },
        {
          displayName: App.localize('Insurer'),
          enableSorting: false,
          field: 'insurerName',
          minWidth: 100,
          width: 140,
          cellTemplate: 'insurerTemplate',
        },
        {
          displayName: App.localize('CaseOrigin'),
          enableSorting: false,
          field: 'caseOrigin',
          minWidth: 100,
          width: 140,
          cellTemplate: 'caseOriginTemplate',
        },
      ],
      onRegisterApi: function (gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, (scope, callback) => {
          vm.requestParams.sorting =
            callback.length && callback[0].field
              ? callback[0].field + ' ' + callback[0].sort.direction
              : null;
          getGuaranteeLetters();
        });
        gridApi.pagination.on.paginationChanged($scope, (newPage, pageSize) => {
          vm.requestParams.skipCount = (newPage - 1) * pageSize;
          vm.requestParams.maxResultCount = pageSize;
          getGuaranteeLetters();
        });
      },
      data: [],
    };

    vm.getGuaranteeLetters = getGuaranteeLetters;
    vm.exportToExcel = exportToExcel;
    vm.lookupDoctors = lookupDoctors;
    vm.setAttendingDoctorId = setAttendingDoctorId;
    vm.showCancelModal = showCancelModal;
    vm.showExpiredGuaranteeLetter = showExpiredGuaranteeLetter;
    vm.getDateTimeString = getDateTimeString;

    /* Functions */

    function init() {
      registerStateParams();
      getListingFilters();

      $timeout(() => {
        vm.gridOptions.paginationCurrentPage = Math.floor(
          vm.requestParams.skipCount / vm.requestParams.maxResultCount + 1
        );
      });
    }

    function setAttendingDoctorId(doctorId) {
      vm.requetParams.attendingDoctorId = doctorId;
    }

    function lookupDoctors(keyword) {
      if (_.isNil(keyword)) return;

      var input = {
        tenantId: tenantId,
        filter: keyword,
        maxResultCount: 5,
      };

      inpatientGuaranteeLetterSvc
        .findHospitalDoctors(input)
        .success((data) => {
          vm.panelDoctors = data.items;
        })
        .finally(() => {});
    }

    function getListingFilters() {
      inpatientGuaranteeLetterSvc.getListingFilters().success((data) => {
        vm.admissionTypes = data.admissionTypes;
        vm.letterStatuses = data.letterStatuses;
        vm.requestTypes = data.requestTypes;
      });
    }

    function getGuaranteeLetters() {
      var input = getRequestInput();

      vm.loading += 1;
      inpatientGuaranteeLetterSvc
        .getInpatientGuaranteeLetters(input)
        .success((data) => {
          vm.gridOptions.data = data.items;
          vm.gridOptions.totalItems = data.totalCount;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function exportToExcel() {
      var input = getRequestInput();

      vm.exporting += 1;
      inpatientGuaranteeLetterSvc
        .getInpatientGuaranteeLettersToExcel(input)
        .success((data) => {
          App.downloadTempFile(data);
        })
        .finally(() => {
          vm.exporting -= 1;
        });
    }

    function getRequestInput() {
      var input = $.extend({}, vm.requestParams);

      input.scheduledAdmissionStartDate = vm.scheduledDateRangeModel.startDate;
      input.scheduledAdmissionEndDate = vm.scheduledDateRangeModel.endDate;

      registerStateParams();

      return input;
    }

    function registerStateParams() {
      var scheduledAdmissionStartDate = vm.scheduledDateRangeModel.startDate
        ? vm.scheduledDateRangeModel.startDate.format('YYYY-MM-DD')
        : null;
      var scheduledAdmissionEndDate = vm.scheduledDateRangeModel.endDate
        ? vm.scheduledDateRangeModel.endDate.format('YYYY-MM-DD')
        : null;

      $state.transitionTo(
        $state.current,
        {
          filter: vm.requestParams.filter,
          skipCount: vm.requestParams.skipCount,
          maxResultCount: vm.requestParams.maxResultCount,
          latestRequestType: vm.requestParams.latestRequestType,
          sorting: vm.requestParams.sorting,
          stateStatus: vm.requestParams.stateStatus,
          patient: vm.requestParams.patient,
          letterNumber: vm.requestParams.letterNumber,
          admissionType: vm.requestParams.admissionType,
          attendingDoctorId: vm.requestParams.attendingDoctorId,
          caseOrigin: vm.requestParams.caseOrigin,
          scheduledAdmissionStartDate: scheduledAdmissionStartDate,
          scheduledAdmissionEndDate: scheduledAdmissionEndDate,
        },
        {
          notify: false,
        }
      );
    }

    // An expired letter can only be cancelled and reapplied for — never rescheduled (HM-11144).

    function showExpiredGuaranteeLetter(guaranteeLetter) {
      expiredGuaranteeLetterFlow.prompt({
        letterNumber: guaranteeLetter.letterNumber,
        scheduledAdmissionTime: guaranteeLetter.scheduledAdmissionTime,
        reapplyParams: {
          employeeId: guaranteeLetter.patientMemberId,
          panelLocationId: guaranteeLetter.panelLocationId,
        },
        onCancelled: () => getGuaranteeLetters(),
      });
    }

    function showCancelModal(letterNumber, letterRequestType, letterStatus) {
      $uibModal
        .open({
          templateUrl: require('/App/clinic/views/hospital/common/cancellationModal/cancel.modal.html'),
          controller: 'clinic.views.hospital.common.cancelModal as vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            letterRequestType: () => {
              return letterRequestType;
            },
            letterStatus: () => {
              return letterStatus;
            },
          },
        })
        .result.then((cancellationReason) => {
          if (cancellationReason) {
            var input = {
              letterNumber: letterNumber,
              cancellationReason: cancellationReason,
            };

            vm.loading += 1;

            hospitalPanelServiceRequestSvc
              .cancelGuaranteeLetterServiceRequest(input)
              .success((data) => {
                abp.notify.success('Cancelled');
              })
              .finally((data) => {
                vm.loading -= 1;
                getGuaranteeLetters();
              });
          }
        });
    }

    function getDateTimeString(date, timeZoneId) {
      return App.getDateTimeString(date, timeZoneId);
    }

    /* End of functions */

    init();
  }
})();
